type DebugValue = unknown;

const parseDebugScopes = (): Set<string> => {
  if (typeof window === 'undefined') return new Set();

  try {
    const params = new URLSearchParams(window.location.search);
    const queryValue = params.get('debug') || params.get('debugScope') || '';
    const storageValue = window.localStorage.getItem('debug') || '';
    const raw = [queryValue, storageValue].filter(Boolean).join(',');

    if (!raw) return new Set();

    return new Set(
      raw
        .split(',')
        .map((scope) => scope.trim().toLowerCase())
        .filter(Boolean)
    );
  } catch {
    return new Set();
  }
};

const isDebugEnabled = (scope?: string): boolean => {
  if (!import.meta.env.DEV) return false;

  const scopes = parseDebugScopes();
  if (scopes.size === 0) return false;
  if (scopes.has('1') || scopes.has('true') || scopes.has('all') || scopes.has('*')) return true;

  if (!scope) return false;
  return scopes.has(scope.toLowerCase());
};

export const debugLog = (scope: string, message: string, ...args: DebugValue[]) => {
  if (!isDebugEnabled(scope)) return;
};

export const debugWarn = (scope: string, message: string, ...args: DebugValue[]) => {
  if (!isDebugEnabled(scope)) return;
  console.warn(`[${scope}] ${message}`, ...args);
};
